import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ProduktTypeService } from '@shared/services/produkt-type.service';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Select } from 'primeng/select';
import { LetInputCprComponent } from '../../../../shared/let-input-cpr/let-input-cpr.component';
import { RisikoOpkraevningerService } from '../risiko-opkraevninger.service';
import { RisikoOpkraevningSearchParams } from './risiko-opkraevning-search-params.model';

@Component({
  selector: 'app-opkraevning-search',
  imports: [
    ScrollPanel,
    Button,
    ReactiveFormsModule,
    InputText,
    Message,
    CheckboxModule,
    LetInputCprComponent,
    Select,
  ],
  templateUrl: './opkraevning-search.component.html',
  styleUrl: './opkraevning-search.component.css',
})
export class OpkraevningSearchComponent {
  opkraevningService = inject(RisikoOpkraevningerService);
  produktTypeService = inject(ProduktTypeService);
  data = this.opkraevningService.datasource.data;

  form = new FormGroup({
    letsikringNr: new FormControl(),
    revisionNr: new FormControl(),
    haendelsesKode: new FormControl(),
    produktType: new FormControl(),
    regnr: new FormControl(),
    cprNummer: new FormControl(),
    reference: new FormControl(),
    opkraevningsType: new FormControl(),
    opkraevningsStatus: new FormControl(),
  });

  onClickSearch() {
    this.opkraevningService.searchRisikoOpkraevning({
      ...(this.form.value as RisikoOpkraevningSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.opkraevningService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });

  opkraevningsTypeOptions = [
    { value: 'Ordinaer', text: 'Ordinær' },
    { value: 'Stumppraemie', text: 'Stumppræmie' },
  ];

  opkraevningsStatusOptions = [
    { value: 'Ny', text: 'Ny' },
    { value: 'SendtTilClearing', text: 'Sendt til clearing' },
    { value: 'ClearingFejl', text: 'Clearing fejl' },
    { value: 'Clearet', text: 'Clearet' },
    { value: 'OpkraevetHosKunde', text: 'Opkraevet hos kunde' },
    { value: 'OpkraevetAfLeverandoer', text: 'Opkraevet af leverandør' },
  ];
}
